import { render, staticRenderFns } from "./diagram_bwg1.vue?vue&type=template&id=26653550&scoped=true&"
import script from "./diagram_bwg1.vue?vue&type=script&lang=js&"
export * from "./diagram_bwg1.vue?vue&type=script&lang=js&"
import style0 from "./diagram_bwg1.vue?vue&type=style&index=0&id=26653550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26653550",
  null
  
)

export default component.exports